import "core-js/modules/es6.regexp.match";

/* eslint-disable prefer-const */

/* eslint-disable no-undef */

/* eslint-disable no-sequences */

/* eslint-disable prefer-destructuring */

/* eslint-disable no-param-reassign */

/* eslint-disable prefer-rest-params */

/* eslint-disable eqeqeq */

/* eslint-disable no-unused-expressions */
// wap端监测代码
// wap端：
// 百度的
// eslint-disable-next-line no-use-before-define
var _hmt = _hmt || [];

(function () {
  var hm = document.createElement('script');
  hm.src = '//hm.baidu.com/hm.js?c8553bf999297be4b7c3bf2ffec7c37f';
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(hm, s);
})(); // 谷歌的


(function () {
  var referrer = document.referrer || ''; // eslint-disable-next-line no-restricted-globals

  var url = location.href; // eslint-disable-next-line no-shadow

  function atmYimao(url) {
    var matchList = url.match(/atm_yimao=([^&=?]+)/);
    return matchList ? matchList[1] : null;
  } // eslint-disable-next-line dot-notation


  if (atmYimao(url) != 1 && atmYimao(referrer) != 1 && !document.cookie['atm_yimao']) {
    (function (i, s, o, g, r, a, m) {
      i.GoogleAnalyticsObject = r;
      i[r] = i[r] || function () {
        (i[r].q = i[r].q || []).push(arguments);
      }, i[r].l = 1 * new Date();
      a = s.createElement(o), m = s.getElementsByTagName(o)[0];
      a.async = 1;
      a.src = g;
      m.parentNode.insertBefore(a, m);
    })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');
  } else {
    document.cookie('atm_yimao=1', path = '/', domain = 'emao.com');

    window.ga = function () {};
  }

  ga('create', 'UA-48162221-3', 'auto');
  ga('send', 'pageview');
})();